import React, { ComponentProps, ReactElement } from 'react';
import Form from 'react-bootstrap/Form';

const FormGroup = ({ className, ...props }: ComponentProps<typeof Form.Group>): ReactElement => (
  <Form.Group className={['app-form-group', className].filter(Boolean).join(' ')} {...props} />
);

export default FormGroup;
